module.exports = __webpack_public_path__ + "img/bet5.835a2b52.png";